module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-view-def"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h1', [_vm._v(_vm._s(_vm.info.infoTitle))]), _vm._v(" "), _c('h2', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.infoSrc),
      expression: "info.infoSrc"
    }]
  }, [_vm._v("来自：" + _vm._s(_vm.info.infoSrc))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm._f("format")(_vm.info.infoDt)) + "  "), _c('span', {
    staticClass: "author"
  }, [_vm._v(_vm._s(_vm.info.infoAuthor))])])]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.info.infoDesc)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-307d2822"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/view.vue
// module id = 788
// module chunks = 10